// change login text to customer login 
document.addEventListener("DOMContentLoaded", function () {
  const loginLink = document.querySelector(".thb-secondary-myaccount span");

  if (loginLink && loginLink.textContent.trim() === "Login") {
    loginLink.textContent = "Customer Login";
  }
});

// add divider on stats
function addDividers() {
  document.querySelectorAll(".stats-columns").forEach((column) => {
    column.querySelectorAll(".divider").forEach((d) => d.remove());

    const cards = column.querySelectorAll(".stat-card");
    let dividerHeight;

    if (window.innerWidth >= 1200) {
      dividerHeight = 298;
    } else if (window.innerWidth >= 768) {
      dividerHeight = 200;
    } else {
      return;
    }

    cards.forEach((card, index) => {
      if (index < cards.length - 1) {
        const divider = document.createElement("div");
        divider.classList.add("divider");
        divider.style.height = `${dividerHeight}px`;
        card.insertAdjacentElement("afterend", divider);
      }
    });
  });
}

const mediaQuery = window.matchMedia("(min-width: 768px)");

function handleViewportChange(e) {
  if (e.matches) {
    addDividers();
    window.addEventListener("resize", addDividers);
  } else {
    document.querySelectorAll(".divider").forEach((d) => d.remove());
    window.removeEventListener("resize", addDividers);
  }
}

mediaQuery.addEventListener("change", handleViewportChange);
handleViewportChange(mediaQuery);

// align multicolum carousel
document.addEventListener("DOMContentLoaded", function () {
  function setBlockHeight(selectors = []) {
    const observer = new MutationObserver((mutations, obs) => {
      const flickityViewports = document.querySelectorAll(".flickity-viewport");
      if (flickityViewports.length > 0) {
        selectors.forEach((selector) => {
          const blocks = document.querySelectorAll(selector);
          blocks.forEach((block) => {
            block.style.height = "100%";
          });
        });

        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  setBlockHeight([
    "product-card.multicolumn__column.carousel__slide",
    "ambassador-block.multicolumn__column.carousel__slide",
  ]);
});

// Close other accordions when one is opened
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".accordion details");

  accordions.forEach((details) => {
    details.addEventListener("toggle", () => {
      if (!details.open) return;

      accordions.forEach((other) => {
        if (other !== details && other.open) {
          const summary = other.querySelector("summary");
          if (summary) {
            summary.click();
          }
        }
      });
    });
  });
});
